import './article_time.css';
import { useAuth } from '../../context/AuthContext';


export const ArticleTime = ({ article }) => {
    const { timeArticles } = useAuth();

    return (
        <>
            {timeArticles && timeArticles.map((timeArticle) => (
                <div className='div-progress' key={timeArticle.id}>
                    {article.id === timeArticle.article_id && (
                        <>
                            <progress className='progress-label' id="file-progress" value={(timeArticle.time/article.duration)*100} max="100"></progress>
                        </>
                    )}
                </div>
            ))}   
        </>
    );
};
